import Vuex from "vuex";
import Vue from "vue";
import account from "@/views/home/vuex-store/account";
import dashboard from "@/views/dashboard/vuex-store/dashboard";
import boxes from "@/views/dashboard/boxes/vuex-store/boxes";
import mail from "@/views/dashboard/mail/vue-store/mail";
import orders from "@/views/dashboard/delivery/vuex-store/orders";
import pay_arrears from "../views/dashboard/pay-arrears/vuex-store/pay_arrears";
import box_renewal from "@/views/dashboard/box-renewal/vuex-store/box_renewal";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    dashboard,
    boxes,
    mail,
    orders,
    pay_arrears,
    box_renewal,
  },
});
